import $ from "jquery";
import "kbw-countdown/dist/js/jquery.plugin";
import "kbw-countdown/dist/js/jquery.countdown";
import {
  validateAllValid,
  removeElementValidation,
  addElementValidation,
} from "./components/validation";
import { scrollTo } from "./components/scrollto";
import gtag from "./components/window.gtag";
import fbq from "./components/window.fbq";
import ttq from "./components/window.ttq";
import snaptr from "./components/window.snaptr";

interface ProductPageItem {
  id: number;
  countdownText: string;
  showCountdown: boolean;
  price: number;
  saleCountdownText: string;
  saleEndYear: number;
  saleEndMonth: number;
  saleEndDay: number;
  saleEndHour: number;
  saleEndMinute: number;
  addedAt: string;
  name: string;
  category: string;
  brand: string;
}

interface MyWindow extends Window {
  pageItem: ProductPageItem;
  basicDrillingIDs: any;
  customDrillingIDs: any;
  endSaleTime: any;
  endTime: any;
  // Add YouTube API interface to Window
  onYouTubeIframeAPIReady?: () => void;
}

declare const window: MyWindow;

if (typeof gtag !== "undefined") {
  gtag("event", "view_item", {
    currency: "USD",
    value: window.pageItem.price,
    items: [
      {
        item_id: `pid_${window.pageItem.id}`,
        item_name: window.pageItem.name,
        currency: "USD",
        price: window.pageItem.price,
        item_brand: window.pageItem.brand,
        item_category: window.pageItem.category,
        google_business_vertical: "retail",
      },
    ],
  });
}

const productNote = document.querySelector(".productNote");
const productNoteRemaining = document.querySelector("#productNoteRemaining");
if (
  typeof productNote !== undefined &&
  productNote !== null &&
  typeof productNoteRemaining !== undefined &&
  productNoteRemaining !== null
) {
  productNote.addEventListener("input", (event) => {
    if (
      !(event.currentTarget instanceof HTMLTextAreaElement) ||
      !(productNoteRemaining instanceof HTMLElement)
    )
      return;
    const target = event.currentTarget;
    const maxLength = 150;
    const currentLength = target.value.length;
    const remaining = maxLength - currentLength;
    productNoteRemaining.innerText = remaining.toString();
  });
}

$(document).ready(() => {
  $("span.showAnswerForm").click((e) => {
    $(e.currentTarget).slideUp("fast", () => {
      $(e.currentTarget).next("div.answerformbox").slideDown("fast");
    });
    e.preventDefault();
  });

  const $hash = window.location.hash;
  if ($hash === "#revbox") {
    scrollTo("#revbox");
  }

  const questposted = document.querySelector("#questposted");
  if (questposted !== null && questposted instanceof HTMLElement) {
    scrollTo("#questbox");
    $("#tb_email").focus();
  }

  if ($hash === "#answerpost") {
    scrollTo("#questbox");
    $("#answerposted").show(500).delay(5000).hide(500);
  }
  if ($hash.indexOf("iq") > -1) {
    if ($hash.length >= 4) {
      scrollTo($hash);
      $(`${$hash} span.showAnswerForm`).slideUp("fast", () => {
        $(`${$hash} span.showAnswerForm`)
          .next("div.answerformbox")
          .slideDown("fast");
      });
    }
  }

  $("#btnPinTop").click((e) => {
    $(e.currentTarget).hide(500);
  });
  $(".showFontImg").click((e) => {
    $(".imgshowFont").show();
    $(e.currentTarget).hide();
  });
  $(".showFontColorImg").click((e) => {
    $(".imgshowFontColor").show();
    $(e.currentTarget).hide();
  });
  $(".showFreeTextDetails").click((e) => {
    $(".freeTextDetails").show();
    $(e.currentTarget).hide();
  });

  $("#form_question").submit((e) => {
    let isValid = true;
    $("#tb_question_validation").hide();
    $("#tb_nickname_validation").hide();
    if ($("#tb_question").val() === "") {
      $("#tb_question_validation").show();
      isValid = false;
    }
    if ($("#tb_nickname").val() === "") {
      $("#tb_nickname_validation").show();
      isValid = false;
    }
    if (!isValid) {
      e.preventDefault();
    }
  });
  $("#form_question_addEmail").submit((e) => {
    let isValid = true;
    $("#tb_email_validation").hide();
    if ($("#tb_email").val() === "") {
      $("#tb_email_validation").show();
      isValid = false;
    }
    if (!isValid) {
      e.preventDefault();
    }
  });
  $("#noThanksQEmail").click((e) => {
    $("#questposted").fadeOut();
    e.preventDefault();
  });
  $(".form_answer").submit((e) => {
    const id = $(e.currentTarget).data("id");
    let isValid = true;
    $(`#tb_answer_${id}_validation`).hide();
    $(`#tb_nickname_${id}_validation`).hide();
    if ($(`#tb_answer_${id}`).val() === "") {
      $(`#tb_answer_${id}_validation`).show();
      isValid = false;
    }
    if ($(`#tb_nickname_${id}`).val() === "") {
      $(`#tb_nickname_${id}_validation`).show();
      isValid = false;
    }
    if (!isValid) {
      e.preventDefault();
    }
  });
});

function HideBlockElement(elem: HTMLElement) {
  elem.classList.remove("d-block");
  elem.classList.add("d-none");
}

function ShowBlockElement(elem: HTMLElement) {
  elem.classList.remove("d-none");
  elem.classList.add("d-block");
}

function weightChange(e: HTMLSelectElement) {
  const currID = parseInt(e.value, 10) || 0;
  const drillProt = document.querySelector("#divDrillingProt") as HTMLElement;
  const drill = document.querySelector("#divDrilling") as HTMLElement;
  const drillMsg = document.querySelector("#drillingMessage") as HTMLElement;
  const dblWarr = document.querySelector("#divDblWarr") as HTMLElement;
  const sixPoundWarranty = document.querySelector(
    "#sixPoundWarranty",
  ) as HTMLElement;
  const drillProtList = document.querySelector(
    "#drpDrillingProt",
  ) as HTMLSelectElement;
  const dblWarrList = document.querySelector(
    "#drpDblWarr",
  ) as HTMLSelectElement;
  const drillList = document.querySelector("#drpDrilling") as HTMLSelectElement;
  const selectedOption = e.querySelector("option:checked");

  if (selectedOption.getAttribute("showWarrantyWarning") === "true") {
    if (drillProt !== null) {
      HideBlockElement(drillProt);
      drillProtList.value = "";
      removeElementValidation("#drpDrillingProt");
      drillProtList.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    }
    if (drill !== null) {
      HideBlockElement(drill);
      drillList.value = "";
      drillList.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    }
    if (dblWarr !== null) {
      HideBlockElement(dblWarr);
      dblWarrList.value = "";
      dblWarrList.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    }
    if (drillMsg !== null) HideBlockElement(drillMsg);
    if (sixPoundWarranty !== null) ShowBlockElement(sixPoundWarranty);
  } else {
    if (drillProt !== null) {
      ShowBlockElement(drillProt);
      addElementValidation("#drpDrillingProt");
      drillProtList.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    }
    if (drill !== null) ShowBlockElement(drill);
    if (dblWarr !== null && dblWarr instanceof Element)
      ShowBlockElement(dblWarr);
    if (sixPoundWarranty !== null && sixPoundWarranty instanceof Element)
      HideBlockElement(sixPoundWarranty);
    if (
      window.basicDrillingIDs.includes(currID) ||
      window.customDrillingIDs.includes(currID)
    ) {
      if (drill !== null) ShowBlockElement(drill);
    } else if (drill !== null) {
      HideBlockElement(drill);
      drillList.value = "";
      drillList.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    }
  }
}

function drillingChange(e: HTMLSelectElement) {
  const currID = parseInt(e.value, 10) || 0;
  const drillMsg = document.querySelector("#drillingMessage") as HTMLElement;
  const drillProtList = document.querySelector(
    "#drpDrillingProt",
  ) as HTMLSelectElement;
  const isShown =
    e.dataset.isShown !== undefined && e.dataset.isShown === "true";
  if (currID !== 0) {
    if (drillMsg !== null && drillMsg instanceof Element)
      ShowBlockElement(drillMsg);
    drillProtList.querySelector("option[value=yes]").innerHTML =
      "Drilling Protection (FREE!)";
    drillProtList.value = "yes";
    drillProtList.setAttribute("disabled", "disabled");
    drillProtList.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    e.dataset.isShown = "true";
  } else if (isShown) {
    if (drillMsg !== null) HideBlockElement(drillMsg);
    drillProtList.querySelector("option[value=yes]").innerHTML =
      "Drilling Protection ($7.95)";
    drillProtList.value = "";
    drillProtList.removeAttribute("disabled");
    drillProtList.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    e.dataset.isShown = "false";
  }
}

if (document.querySelector("#div_prodchoices") !== null) {
  document
    .querySelector("#div_prodchoices")
    .addEventListener("change", (event) => {
      if (event.target instanceof Element) {
        const weightDDL = event.target.closest(".weightDDL");
        const drpDrilling = event.target.closest("#drpDrilling");
        if (weightDDL !== null && weightDDL instanceof HTMLSelectElement)
          weightChange(weightDDL);
        if (drpDrilling !== null && drpDrilling instanceof HTMLSelectElement)
          drillingChange(drpDrilling);
      }
    });
}

function hideCountdown() {
  this.classList.remove("show");
}

function serverTime(): Date {
  const url = new URL("/api/servertime", document.location.toString());
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, false); // false makes the request synchronous
  xhr.send(null);
  if (xhr.status === 200) {
    console.log(xhr.responseText);
    console.log(new Date(xhr.responseText));
    return new Date(xhr.responseText);
  } else {
    console.log("Error getting server time");
    return new Date();
  }
}

const shipCounter = document.querySelector("#shipCounter");
if (window.pageItem.showCountdown && shipCounter !== null) {
  $("#shipCounter").countdown({
    until: new Date(window.endTime),
    serverSync: serverTime,
    layout: `${window.pageItem.countdownText} <span id="counterBox" class="text-dark font-weight-bold">{hnn}{sep}{mnn}{sep}{snn}</span>`,
    onExpiry: hideCountdown,
  });
}

if (window.pageItem.saleCountdownText.length > 0) {
  if (
    window.pageItem.saleCountdownText[
      window.pageItem.saleCountdownText.length - 1
    ] === " "
  ) {
    $("#saleCounter").countdown({
      until: new Date(window.endSaleTime),
      serverSync: serverTime,
      layout: `<span class="text-danger">${window.pageItem.saleCountdownText}</span> <strong><span id="counterBox" class="text-danger font-weight-bold">{hnn}{sep}{mnn}{sep}{snn}</span></strong>`,
      onExpiry: hideCountdown,
    });
  } else {
    $("#saleCounter").countdown({
      until: new Date(window.endTime),
      serverSync: serverTime,
      layout: `<strong>${window.pageItem.saleCountdownText}</strong>`,
      onExpiry: hideCountdown,
    });
  }
}

const sortRev = document.querySelector("#sortRev");
if (sortRev !== null && sortRev instanceof HTMLSelectElement) {
  sortRev.addEventListener("change", (e) => {
    sortRev.closest("form").submit();
  });
}

// Updated YouTube API TypeScript interfaces
interface YTPlayer {
  pauseVideo: () => void;
  stopVideo: () => void;
  destroy: () => void;
  playVideo: () => void;
  // Add other YouTube Player methods as needed
}

interface YTEvent {
  target: YTPlayer;
}

interface YTPlayerOptions {
  videoId: string;
  width?: string | number;
  height?: string | number;
  playerVars?: {
    autoplay?: number;
    controls?: number;
    rel?: number;
    modestbranding?: number;
    showinfo?: number;
    fs?: number;
    iv_load_policy?: number;
    // Add other player parameters as needed
  };
  events?: {
    onReady?: (event: YTEvent) => void;
    onStateChange?: (event: YTEvent) => void;
    onError?: (event: YTEvent) => void;
    // Add other event handlers as needed
  };
}

interface YTNamespace {
  Player: new (
    elementId: string | HTMLElement,
    options: YTPlayerOptions,
  ) => YTPlayer;
}

declare global {
  const YT: YTNamespace;
}

$(document).ready(function () {
  // Parse the query string to find the 'section' parameter
  const urlParams: URLSearchParams = new URLSearchParams(
    window.location.search,
  );
  const section: string | null = urlParams.get("section");

  // If there's a section parameter
  if (section) {
    // Find the element to scroll to
    const $element: JQuery<HTMLElement> = $("#" + section);

    // If the element exists, scroll to it
    if ($element.length) {
      // Scroll to the element (with a slight offset from the top)
      $("html, body").animate(
        {
          scrollTop: $element.offset()?.top ?? 0 - 80, // Adjust the offset as needed
        },
        800,
      ); // Adjust animation speed as needed

      // Remove the query string from the URL without reloading the page
      const newUrl: string =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;

      // Replace the current URL in the browser history
      window.history.replaceState({ path: newUrl }, "", newUrl);
    }
  }
});

document.addEventListener("submit", (e) => {
  console.log(e);
  if (e.target instanceof HTMLFormElement) {
    if (
      e.target.id === "emailGcForm" ||
      e.target.id === "mailGcForm" ||
      e.target.id === "addItemForm"
    ) {
      // validation
      if (!validateAllValid()) {
        e.preventDefault();
        e.stopPropagation();
      } else {
        const button: HTMLButtonElement | null = e.target.querySelector(
          'button[type="submit"]',
        );
        if (button) {
          button.innerHTML =
            'Adding&nbsp;&nbsp;<i class="fa-solid fa-spinner fa-spin"></i>';
          //setTimeout(() => {
          //    button.innerHTML = 'Add to Cart&nbsp;&nbsp;<i class="fa-solid fa-cart-plus"></i>';
          //}, 3000); // Revert after 2 seconds
        }

        if (typeof gtag !== "undefined") {
          gtag("event", "add_to_cart", {
            currency: "USD",
            value: window.pageItem.price,
            items: [
              {
                id: `pid_${window.pageItem.id}`,
                google_business_vertical: "retail",
              },
            ],
          });
        }

        if (typeof fbq !== "undefined") {
          fbq("track", "AddToCart", {
            content_ids: [`pid_${window.pageItem.id}`],
            content_type: "product_group",
            value: window.pageItem.price,
            currency: "USD",
          });
        }
        
        if(typeof snaptr !== undefined) {
          snaptr("track", "ADD_CART", {
            'item_ids': [`pid_${window.pageItem.id}`],
            'price': window.pageItem.price,
            'currency': "USD",
            'number_items': 1,
          });
        }

        if (typeof ttq !== "undefined") {
          ttq.track("AddToCart", {
            contents: [
              {
                content_id: `pid_${window.pageItem.id}`,
                content_type: "product_group",
              },
            ],
            value: window.pageItem.price,
            currency: "USD",
          });
        }
      }
    }
  }
});

// Initialize the product viewer functionality

// Wait for the DOM to be fully loaded before running the script
document.addEventListener("DOMContentLoaded", (): void => {
  // Get elements
  const mainImage: HTMLImageElement | null = document.getElementById(
    "mainProductImage",
  ) as HTMLImageElement;
  const mainVidImage: HTMLElement | null = document.getElementById(
    "mainVideoImage",
  ) as HTMLElement;
  const mainVid: HTMLIFrameElement | null = document.getElementById(
    "mainVideo",
  ) as HTMLIFrameElement;
  const thumbnailContainer: HTMLElement | null =
    document.getElementById("thumbnail-list");
  const thumbnailWrapper: HTMLElement | null = document.querySelector(
    ".thumbnail-list-wrapper",
  );
  const prevButton: HTMLElement | null = document.getElementById("prevButton");
  const nextButton: HTMLElement | null = document.getElementById("nextButton");
  const mainImageContainer: HTMLElement | null = document.querySelector(
    ".main-image-container",
  );
  const paginationDotsContainer: HTMLElement | null =
    document.querySelector(".pagination-dots");
  // other styles
  const styleContainer: HTMLElement | null =
    document.getElementById("style-list");
  const styleWrapper: HTMLElement | null = document.querySelector(
    ".style-list-wrapper",
  );
  const recContainer: HTMLElement | null = document.getElementById("rec-list");
  const recWrapper: HTMLElement | null =
    document.querySelector(".rec-list-wrapper");
  const similarContainer: HTMLElement | null =
    document.getElementById("similar-list");
  const similarWrapper: HTMLElement | null = document.querySelector(
    ".similar-list-wrapper",
  );

  // Check if essential elements are found
  if (
    !mainImage ||
    !thumbnailContainer ||
    !prevButton ||
    !nextButton ||
    !mainImageContainer ||
    !paginationDotsContainer
  ) {
    return; // Exit if elements are missing
  }

  // YouTube API state
  let youtubeAPIReady = false;
  let currentYouTubePlayer: YTPlayer | null = null;

  // Load YouTube API if we have video thumbnails
  const hasVideoThumbnails = Array.from(
    thumbnailContainer.querySelectorAll(".thumbnail-item img"),
  ).some((img) =>
    (img as HTMLImageElement).dataset.largeSrc?.includes("youtube"),
  );

  if (hasVideoThumbnails) {
    // Ensure we only load the API once
    if (!document.getElementById("youtube-api-script")) {
      // Create and load YouTube API script
      const tag = document.createElement("script");
      tag.id = "youtube-api-script";
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    }

    // This function will be called when the YouTube API is ready
    window.onYouTubeIframeAPIReady = function (): void {
      youtubeAPIReady = true;
      console.log("YouTube API is ready");
    };
  }

  // Match thumbnail container height with main image container
  const matchContainerHeights = (): void => {
    if (mainImageContainer && thumbnailWrapper) {
      // Only apply on desktop/tablet views where the layout is vertical
      if (window.innerWidth >= 992) {
        const mainImageHeight: number = mainImageContainer.offsetHeight;
        thumbnailWrapper.style.height = mainImageHeight + "px";
      } else {
        // Reset height on mobile
        thumbnailWrapper.style.height = "auto";
      }
    }
  };

  // Call on page load
  matchContainerHeights();
  // Recalculate on window resize
  window.addEventListener("resize", matchContainerHeights);

  // Scroll detection for showing/hiding fades
  if (thumbnailContainer && thumbnailWrapper) {
    // Add scroll event listener
    thumbnailContainer.addEventListener("scroll", (): void => {
      // For vertical scrolling (desktop)
      if (window.innerWidth >= 992) {
        // Show/hide top fade based on scroll position
        if (thumbnailContainer.scrollTop > 10) {
          thumbnailWrapper.classList.add("scrolled-down");
        } else {
          thumbnailWrapper.classList.remove("scrolled-down");
        }

        // Check if scrolled to bottom to hide bottom fade
        const isAtBottom: boolean =
          thumbnailContainer.scrollHeight -
            thumbnailContainer.scrollTop -
            thumbnailContainer.clientHeight <
          1;
        thumbnailWrapper.classList.toggle("scrolled-end", isAtBottom);
      }
      // For horizontal scrolling (mobile)
      else {
        // Show/hide left fade based on scroll position
        if (thumbnailContainer.scrollLeft > 10) {
          thumbnailWrapper.classList.add("scrolled-down");
        } else {
          thumbnailWrapper.classList.remove("scrolled-down");
        }

        // Check if scrolled to rightmost edge to hide right fade
        const isAtRight: boolean =
          thumbnailContainer.scrollWidth -
            thumbnailContainer.scrollLeft -
            thumbnailContainer.clientWidth <
          1;
        thumbnailWrapper.classList.toggle("scrolled-end", isAtRight);
      }
    });

    // Initial check for scroll position
    const checkInitialScroll = (): void => {
      // Small delay to allow layout rendering, especially after resize
      setTimeout((): void => {
        // For vertical layout (desktop)
        if (window.innerWidth >= 992) {
          // Top fade
          if (thumbnailContainer.scrollTop > 10) {
            thumbnailWrapper.classList.add("scrolled-down");
          } else {
            thumbnailWrapper.classList.remove("scrolled-down"); // Ensure it's removed if not scrolled
          }

          // Bottom fade
          const isAtBottom: boolean =
            thumbnailContainer.scrollHeight -
              thumbnailContainer.scrollTop -
              thumbnailContainer.clientHeight <
            1;
          thumbnailWrapper.classList.toggle("scrolled-end", isAtBottom);
        }
        // For horizontal layout (mobile)
        else {
          // Left fade
          if (thumbnailContainer.scrollLeft > 10) {
            thumbnailWrapper.classList.add("scrolled-down");
          } else {
            thumbnailWrapper.classList.remove("scrolled-down"); // Ensure it's removed if not scrolled
          }

          // Right fade
          const isAtRight: boolean =
            thumbnailContainer.scrollWidth -
              thumbnailContainer.scrollLeft -
              thumbnailContainer.clientWidth <
            1;
          thumbnailWrapper.classList.toggle("scrolled-end", isAtRight);
        }
      }, 50); // 50ms delay, adjust if needed
    };

    // Initial check
    checkInitialScroll();
    // Also check after images have loaded (which can change content size)
    window.addEventListener("load", checkInitialScroll);
    // Check after window resize as layout might change
    window.addEventListener("resize", checkInitialScroll);
  }

  // Get all thumbnail image elements
  const thumbnails: NodeListOf<HTMLImageElement> =
    thumbnailContainer.querySelectorAll(".thumbnail-item img");
  if (thumbnails.length === 0) {
    console.warn("No thumbnails found.");
    // Optionally hide controls if there's only one image (or none)
    if (prevButton) prevButton.style.display = "none";
    if (nextButton) nextButton.style.display = "none";
    return;
  }

  // Create unique thumbnails list (to avoid duplicates for pagination dots)
  const uniqueThumbnailSrcs: Set<string> = new Set<string>();
  const uniqueThumbnails: HTMLImageElement[] = [];

  // Get unique thumbnails based on their large source URL
  thumbnails.forEach((thumb: HTMLImageElement): void => {
    const largeSrc: string = thumb.dataset.largeSrc || "";
    if (!uniqueThumbnailSrcs.has(largeSrc)) {
      uniqueThumbnailSrcs.add(largeSrc);
      uniqueThumbnails.push(thumb);
    }
  });

  // Create pagination dots based on unique thumbnails
  const createPaginationDots = (): void => {
    paginationDotsContainer.innerHTML = ""; // Clear existing dots

    uniqueThumbnails.forEach((_, index: number): void => {
      const dot: HTMLDivElement = document.createElement("div");
      dot.className = "pagination-dot";
      dot.dataset.index = index.toString();

      // Add click event to each dot
      dot.addEventListener("click", (e: Event): void => {
        e.preventDefault(); // Prevent default action
        e.stopPropagation();
        // Find the first thumbnail with matching source
        const targetSrc: string =
          uniqueThumbnails[index].dataset.largeSrc || "";
        const targetIndex: number = Array.from(thumbnails).findIndex(
          (thumb: HTMLImageElement): boolean =>
            (thumb.dataset.largeSrc || "") === targetSrc,
        );
        if (targetIndex >= 0) {
          updateImageViewer(targetIndex);
        }
      });

      paginationDotsContainer.appendChild(dot);
    });
  };

  // Update the pagination dots to show the active one
  const updatePaginationDots = (activeIndex: number): void => {
    const dots: NodeListOf<HTMLDivElement> =
      paginationDotsContainer.querySelectorAll(".pagination-dot");
    if (!dots.length) return;

    // Get the large source of the active thumbnail
    const activeSrc: string = thumbnails[activeIndex].dataset.largeSrc || "";

    // Find the index in unique thumbnails
    const uniqueIndex: number = Array.from(uniqueThumbnails).findIndex(
      (thumb: HTMLImageElement): boolean =>
        (thumb.dataset.largeSrc || "") === activeSrc,
    );

    // Update the active state of pagination dots
    dots.forEach((dot: HTMLDivElement, index: number): void => {
      dot.classList.toggle("active", index === uniqueIndex);
    });
  };

  let currentIndex: number = 0; // Keep track of the currently displayed image index

  // Get YouTube video ID helper
  const getYouTubeId = (url: string): string | null => {
    if (!url || !url.includes("youtube")) return null;

    // Try to extract from various YouTube URL formats
    const embedMatch = url.match(/\/embed\/([^/?&]+)/);
    if (embedMatch) return embedMatch[1];

    const videoIdMatch = url.match(/[?&]v=([^?&]+)/);
    if (videoIdMatch) return videoIdMatch[1];

    return null;
  };

  // Helper function to completely clean YouTube videos
  const cleanupYouTubeVideos = (): void => {
    // First destroy the YouTube player if it exists
    if (currentYouTubePlayer) {
      try {
        currentYouTubePlayer.stopVideo();
        currentYouTubePlayer.destroy();
      } catch (e) {
        console.warn("Error cleaning up YouTube player:", e);
      }
      currentYouTubePlayer = null;
    }

    // Find and remove all iframes in the video container
    const videoContainer = document.getElementById("mainVideoImage");
    if (videoContainer) {
      // Clear everything inside the container
      const wrapper = videoContainer.querySelector(".video-wrapper");
      if (wrapper) {
        // Remove all iframes
        const iframes = wrapper.querySelectorAll("iframe");
        iframes.forEach((iframe) => {
          if (iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }
        });

        // Also remove any divs created by YouTube API
        const ytDivs = wrapper.querySelectorAll('div[id^="youtube-player"]');
        ytDivs.forEach((div) => {
          if (div.parentNode) {
            div.parentNode.removeChild(div);
          }
        });
      }
    }
  };
  const initYouTubePlayer = (videoId: string): void => {
    // First, ensure we clean up properly
    if (currentYouTubePlayer) {
      try {
        currentYouTubePlayer.destroy();
      } catch (e) {
        console.warn("Error destroying previous YouTube player:", e);
      }
      currentYouTubePlayer = null;
    }

    // Important: Find the current video container element (might have changed)
    let videoContainer = document.getElementById("mainVideoImage");
    if (!videoContainer) return;

    // Remove any existing iframes inside the container
    const existingIframes = videoContainer.querySelectorAll("iframe");
    existingIframes.forEach((iframe) => {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    });

    // Create fresh placeholder for the YouTube player
    const playerDiv = document.createElement("div");
    playerDiv.id = "youtube-player-container-" + new Date().getTime(); // Unique ID to avoid conflicts

    // Make sure wrapper exists
    const wrapper = videoContainer.querySelector(".video-wrapper");
    if (wrapper) {
      wrapper.appendChild(playerDiv);
    } else {
      videoContainer.appendChild(playerDiv);
    }

    // Now initialize the YouTube player on the fresh placeholder
    if (youtubeAPIReady) {
      try {
        currentYouTubePlayer = new YT.Player(playerDiv.id, {
          videoId: videoId,
          width: "100%",
          height: "100%",
          playerVars: {
            rel: 0,
            modestbranding: 1,
            controls: 1,
          },
          events: {
            onReady: (event: YTEvent) => {
              console.log("YouTube player ready");
            },
            onError: (event: YTEvent) => {
              console.error("YouTube player error:", event);
            },
          },
        });
      } catch (e) {
        console.error("Error initializing YouTube player:", e);
      }
    } else {
      console.warn("YouTube API not ready yet");

      // Create an iframe directly (fallback)
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.youtube.com/embed/${videoId}?rel=0&controls=1`;
      iframe.width = "100%";
      iframe.height = "100%";
      iframe.allowFullscreen = true;
      iframe.setAttribute("frameborder", "0");

      if (wrapper) {
        wrapper.appendChild(iframe);
      } else {
        videoContainer.appendChild(iframe);
      }
    }
  };

  // CRITICAL FUNCTION: Update the image viewer without affecting history
  const updateImageViewer = (index: number): void => {
    // Basic index bounds check
    if (index < 0 || index >= thumbnails.length) {
      // Wrap around logic
      if (index < 0) index = thumbnails.length - 1;
      if (index >= thumbnails.length) index = 0;
      // If still invalid after wrapping (e.g., no thumbnails), return.
      if (index < 0 || index >= thumbnails.length) return;
    }

    const selectedThumbnail: HTMLImageElement = thumbnails[index];
    const largeSrc: string = selectedThumbnail?.dataset.largeSrc || "";

    if (selectedThumbnail && largeSrc && mainImage && mainVidImage) {
      if (largeSrc.includes("youtube")) {
        // It's a YouTube video
        const videoId = getYouTubeId(largeSrc);

        if (videoId) {
          // Make sure to completely clean up first
          cleanupYouTubeVideos();

          // Update display state immediately
          mainVidImage.style.display = "block";
          mainImage.style.display = "none";
          mainVidImage.title = selectedThumbnail.alt.replace(
            "Thumbnail",
            "Product Video",
          );

          // Initialize new YouTube player with delay to ensure DOM is ready
          setTimeout(() => {
            initYouTubePlayer(videoId);
          }, 50);
        }
      } else {
        // It's a regular image
        if (
          mainImage.src !== largeSrc ||
          mainVidImage.style.display === "block"
        ) {
          // Make sure to completely clean up previous video content
          cleanupYouTubeVideos();

          // Force immediate display changes
          mainVidImage.style.display = "none";
          mainImage.style.display = "block";

          // Update the image (after display changes to avoid flicker)
          mainImage.src = largeSrc;
          mainImage.alt = selectedThumbnail.alt.replace(
            "Thumbnail",
            "Product Image",
          );
        }
      }

      // Update active state on thumbnails
      thumbnails.forEach((thumb: HTMLImageElement, i: number): void => {
        thumb.classList.toggle("active", i === index);
      });

      // Update the current index
      currentIndex = index;

      // Update the pagination dots
      updatePaginationDots(index);
    }
  };

  // --- Event Listeners ---

  // Add click listener to each thumbnail
  thumbnails.forEach((thumb: HTMLImageElement, index: number): void => {
    thumb.addEventListener("click", (e: Event): void => {
      e.preventDefault(); // Prevent default action which might change URL
      e.stopPropagation();
      updateImageViewer(index);
    });

    // Optional: Keep hover effect if desired, or remove if click is preferred
    thumb.addEventListener("mouseenter", (e: Event): void => {
      e.preventDefault(); // Prevent default action
      e.stopPropagation();
      // Uncomment below line if you want hover to change image too
      updateImageViewer(index);
    });
  });

  // Add click listener for the 'Previous' button
  prevButton.addEventListener("click", (e: Event): void => {
    e.preventDefault(); // Prevent default action
    e.stopPropagation();
    const newIndex: number =
      (currentIndex - 1 + thumbnails.length) % thumbnails.length;
    updateImageViewer(newIndex);
  });

  // Add click listener for the 'Next' button
  nextButton.addEventListener("click", (e: Event): void => {
    e.preventDefault(); // Prevent default action
    e.stopPropagation();
    const newIndex: number = (currentIndex + 1) % thumbnails.length;
    updateImageViewer(newIndex);
  });

  // --- Swipe functionality for touch devices ---
  let touchStartX: number = 0;
  let touchEndX: number = 0;
  const minSwipeDistance: number = 50; // Minimum distance required for a swipe

  // Touch start event
  mainImageContainer.addEventListener(
    "touchstart",
    (e: TouchEvent): void => {
      touchStartX = e.changedTouches[0].screenX;
    },
    { passive: true },
  );

  // Touch end event
  mainImageContainer.addEventListener(
    "touchend",
    (e: TouchEvent): void => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    },
    { passive: true },
  );

  // Handle the swipe
  const handleSwipe = (): void => {
    const swipeDistance: number = touchEndX - touchStartX;

    // If swipe distance is less than the minimum, don't do anything
    if (Math.abs(swipeDistance) < minSwipeDistance) return;

    if (swipeDistance > 0) {
      // Swiped right - show previous image
      const newIndex: number =
        (currentIndex - 1 + thumbnails.length) % thumbnails.length;
      updateImageViewer(newIndex);
    } else {
      // Swiped left - show next image
      const newIndex: number = (currentIndex + 1) % thumbnails.length;
      updateImageViewer(newIndex);
    }
    // Reset values
    touchStartX = 0;
    touchEndX = 0;
  };

  // --- Initialization ---
  // Create pagination dots
  createPaginationDots();

  // Set the initial state based on the first thumbnail or the one marked 'active'
  const initialActiveIndex: number = Array.from(thumbnails).findIndex(
    (thumb: HTMLImageElement): boolean => thumb.classList.contains("active"),
  );
  updateImageViewer(initialActiveIndex >= 0 ? initialActiveIndex : 0);

  // Final check on scroll state after initial load and image setting
  const initialEvent: Event = new Event("scroll");
  thumbnailContainer.dispatchEvent(initialEvent);

  if (styleContainer && styleWrapper) {
    // Create and append scroll arrow elements
    const leftArrow: HTMLDivElement = document.createElement("div");
    leftArrow.className = "scroll-arrow scroll-arrow-left";
    styleWrapper.appendChild(leftArrow);

    const rightArrow: HTMLDivElement = document.createElement("div");
    rightArrow.className = "scroll-arrow scroll-arrow-right";
    styleWrapper.appendChild(rightArrow);

    // Function to handle scroll position and update UI state
    const updateScrollState = (): void => {
      // Show/hide left fade and arrow based on scroll position
      if (styleContainer.scrollLeft > 10) {
        styleWrapper.classList.add("scrolled-down");
      } else {
        styleWrapper.classList.remove("scrolled-down");
      }

      // Check if scrolled to rightmost edge to hide right fade and arrow
      const isAtRight: boolean =
        styleContainer.scrollWidth -
          styleContainer.scrollLeft -
          styleContainer.clientWidth <
        1;
      styleWrapper.classList.toggle("scrolled-end", isAtRight);
    };

    // Function to scroll left
    const scrollLeft = (): void => {
      // Scroll left by the width of 3 items (300px) with smooth animation
      styleContainer.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    };

    // Function to scroll right
    const scrollRight = (): void => {
      // Scroll right by the width of 3 items (300px) with smooth animation
      styleContainer.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    };

    // Add event listeners for scroll buttons
    leftArrow.addEventListener("click", scrollLeft);
    rightArrow.addEventListener("click", scrollRight);

    // Add scroll event listener to update UI state
    styleContainer.addEventListener("scroll", (e: Event): void => {
      e.preventDefault(); // Prevent default action
      e.stopPropagation();
      updateScrollState();
    });

    // Initial check for scroll position
    const checkInitialStyleScroll = (): void => {
      // Small delay to allow layout rendering, especially after resize
      setTimeout((): void => {
        updateScrollState();
      }, 50); // 50ms delay, adjust if needed
    };

    // Initial check
    checkInitialStyleScroll();
    // Also check after images have loaded (which can change content size)
    window.addEventListener("load", checkInitialStyleScroll);
    // Check after window resize as layout might change
    window.addEventListener("resize", checkInitialStyleScroll);
  }

  if (recContainer && recWrapper) {
    // Create and append scroll arrow elements
    const leftArrow: HTMLDivElement = document.createElement("div");
    leftArrow.className = "scroll-arrow scroll-arrow-left";
    recWrapper.appendChild(leftArrow);

    const rightArrow: HTMLDivElement = document.createElement("div");
    rightArrow.className = "scroll-arrow scroll-arrow-right";
    recWrapper.appendChild(rightArrow);

    // Function to handle scroll position and update UI state
    const updateScrollState = (): void => {
      // Show/hide left fade and arrow based on scroll position
      if (recContainer.scrollLeft > 10) {
        recWrapper.classList.add("scrolled-down");
      } else {
        recWrapper.classList.remove("scrolled-down");
      }

      // Check if scrolled to rightmost edge to hide right fade and arrow
      const isAtRight: boolean =
        recContainer.scrollWidth -
          recContainer.scrollLeft -
          recContainer.clientWidth <
        1;
      recWrapper.classList.toggle("scrolled-end", isAtRight);
    };

    // Function to scroll left
    const scrollLeft = (): void => {
      // Scroll left by the width of 3 items (300px) with smooth animation
      recContainer.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    };

    // Function to scroll right
    const scrollRight = (): void => {
      // Scroll right by the width of 3 items (300px) with smooth animation
      recContainer.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    };

    // Add event listeners for scroll buttons
    leftArrow.addEventListener("click", scrollLeft);
    rightArrow.addEventListener("click", scrollRight);

    // Add scroll event listener to update UI state
    recContainer.addEventListener("scroll", (e: Event): void => {
      e.preventDefault(); // Prevent default action
      e.stopPropagation();
      updateScrollState();
    });

    // Initial check for scroll position
    const checkInitialStyleScroll = (): void => {
      // Small delay to allow layout rendering, especially after resize
      setTimeout((): void => {
        updateScrollState();
      }, 50); // 50ms delay, adjust if needed
    };

    // Initial check
    checkInitialStyleScroll();
    // Also check after images have loaded (which can change content size)
    window.addEventListener("load", checkInitialStyleScroll);
    // Check after window resize as layout might change
    window.addEventListener("resize", checkInitialStyleScroll);
  }

  if (similarContainer && similarWrapper) {
    // Create and append scroll arrow elements
    const leftArrow: HTMLDivElement = document.createElement("div");
    leftArrow.className = "scroll-arrow scroll-arrow-left";
    similarWrapper.appendChild(leftArrow);

    const rightArrow: HTMLDivElement = document.createElement("div");
    rightArrow.className = "scroll-arrow scroll-arrow-right";
    similarWrapper.appendChild(rightArrow);

    // Function to handle scroll position and update UI state
    const updateScrollState = (): void => {
      // Show/hide left fade and arrow based on scroll position
      if (similarContainer.scrollLeft > 10) {
        similarWrapper.classList.add("scrolled-down");
      } else {
        similarWrapper.classList.remove("scrolled-down");
      }

      // Check if scrolled to rightmost edge to hide right fade and arrow
      const isAtRight: boolean =
        similarContainer.scrollWidth -
          similarContainer.scrollLeft -
          similarContainer.clientWidth <
        1;
      similarWrapper.classList.toggle("scrolled-end", isAtRight);
    };

    // Function to scroll left
    const scrollLeft = (): void => {
      // Scroll left by the width of 3 items (300px) with smooth animation
      similarContainer.scrollBy({
        left: -300,
        behavior: "smooth",
      });
    };

    // Function to scroll right
    const scrollRight = (): void => {
      // Scroll right by the width of 3 items (300px) with smooth animation
      similarContainer.scrollBy({
        left: 300,
        behavior: "smooth",
      });
    };

    // Add event listeners for scroll buttons
    leftArrow.addEventListener("click", scrollLeft);
    rightArrow.addEventListener("click", scrollRight);

    // Add scroll event listener to update UI state
    similarContainer.addEventListener("scroll", (e: Event): void => {
      e.preventDefault(); // Prevent default action
      e.stopPropagation();
      updateScrollState();
    });

    // Initial check for scroll position
    const checkInitialStyleScroll = (): void => {
      // Small delay to allow layout rendering, especially after resize
      setTimeout((): void => {
        updateScrollState();
      }, 50); // 50ms delay, adjust if needed
    };

    // Initial check
    checkInitialStyleScroll();
    // Also check after images have loaded (which can change content size)
    window.addEventListener("load", checkInitialStyleScroll);
    // Check after window resize as layout might change
    window.addEventListener("resize", checkInitialStyleScroll);
  }
}); // End DOMContentLoaded
